import React, { useEffect } from 'react'
import { Table, TablePaginationConfig } from 'antd'
import moment from 'moment'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { getPaymentsAction } from 'slices/payment'
import { ClientProfile, Payment } from 'types'
import addCurrencySymbol from 'utils/addCurrencySymbol'

/**
 * Hardcoded size of the table
 */
const size = 10

const PaymentsTable: React.FC = () => {
	const dispatch = useAppDispatch()
	const { records, currentPage, totalCount, loading } = useAppSelector(
		state => state.payment
	)
	/**
	 * Pagination config for the table
	 */
	const pagination = {
		current: currentPage,
		total: totalCount,
		pageSize: size,
	}

	useEffect(() => {
		const options = {
			page: pagination.current,
			size: pagination.pageSize,
		}
		dispatch(getPaymentsAction(options))
	}, [dispatch])

	/**
	 * Handles pagination change by changing the current page in the store.
	 *
	 * @param page - Pagination object from the table
	 */

	const handlePageChange = (page: TablePaginationConfig) => {
		const options = {
			page: page.current || 1,
			size: page.pageSize || size,
		}
		dispatch(getPaymentsAction(options))
	}

	/**
	 * Columns for the table of Invoice
	 */

	const columns = [
		{
			title: 'Payment ID',
			dataIndex: 'paymentId',
		},
		{
			title: 'Amount',
			dataIndex: 'amount',
			render: (amount: number, record: Payment) =>
				addCurrencySymbol(
					amount,
					record.currency ?? record.client.currency_selected
				),
		},
		{
			title: 'Client Name',
			dataIndex: 'client',
			render: (client: ClientProfile) => (client ? client.organizationName : '--'),
		},
		{
			title: 'Client Email',
			dataIndex: 'client',
			render: (client: ClientProfile) => (client ? client.email : '--'),
		},
		{
			title: 'Date',
			dataIndex: 'createdAt',
			render: (createdAt: string) => moment(createdAt).format('DD/MM/YYYY'),
		},
		{
			title: 'Invoice Number',
			dataIndex: ['invoice', 'number'],
		},
		{
			title: 'Transaction Mode',
			dataIndex: 'txnMode',
		},
		{
			title: 'Transaction Channel',
			dataIndex: 'txnChannel',
		},
		{
			title: 'Transaction Type',
			dataIndex: 'txnType',
		},
		{
			title: 'Receipt',
			dataIndex: 'url',
		},
		{
			title: 'Remarks',
			dataIndex: 'remarks',
			render: (remarks: string) => remarks || '--',
		},
	]

	return (
		<Table
			columns={columns}
			rowKey={record => record._id}
			dataSource={records}
			pagination={{ ...pagination, position: ['bottomCenter'] }}
			loading={loading}
			onChange={handlePageChange}
			scroll={{ x: 'fit-content' }}
		/>
	)
}

export default PaymentsTable
